import { Component, ChangeDetectionStrategy } from "@angular/core";
import { UserVerificationFacade } from "@modules/+new/payments/shared-payments/components/user-verification/domain/+state/user-verification.facade";

@Component({
	selector: "not-verified-user",
	templateUrl: "./user-verification.component.html",
	styleUrls: ["./user-verification.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [UserVerificationFacade],
	standalone: false
})
export class UserVerificationComponent {
	public constructor(private readonly userVerificationFacade: UserVerificationFacade) {}

	public isVerificationPending(): boolean {
		return this.userVerificationFacade.isVerificationPending();
	}

	public verify(): void {
		this.userVerificationFacade.verify();
	}
}
